import { IncotermGoupEnum, StatusTicketEnum } from '@types'

export const INPUT_INT_NUMBER_ACCEPT_KEYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
]

const { TRANSIT, NO_SHOW, CANCELED, DELIVERED } = StatusTicketEnum

export const ticketStatusToDisablePrimaryButtonforAdmin = [TRANSIT, NO_SHOW, CANCELED, DELIVERED]

export const PAGINATION_KEYS = {
  PAGE: 1,
  LIMIT: 10,
}

export const PAGINATION_CARRIERS_KEYS = {
  PAGE: 1,
  LIMIT: 20,
}

interface TimeOption {
  value: string
  labelKey: string
  intValue: number
}

export const TIME_OPTIONS_CONFIG: TimeOption[] = [
  { value: '12:00', labelKey: 'globals.morning_shift', intValue: 12 },
  { value: '17:00', labelKey: 'globals.afternoon_shift', intValue: 17 },
]

export const defaultTelephonePreffix = '54'
export const defaultPhonePrefixes: Record<number, string> = {
  1: '54',
  2: '57',
}

export const forbiddenSupplierEditionStatus = [NO_SHOW, CANCELED, DELIVERED]

const FOB_GROUP = ['FOB', 'FCA', 'EXW']
const CFR_GROUP = ['CIF', 'CFR', 'CPT']

export const INCOTERM_GROUPS: Record<IncotermGoupEnum, string[]> = {
  FOB: FOB_GROUP,
  CFR: CFR_GROUP,
} as const

export const ASSIGNATION_OPTIONS = ['automatic', 'manual'] as const

export const countryCodeByCompanyId = {
  1: 'AR',
  2: 'COL',
}

export const SUGGESTION_OPTION_CLASS_NAME = 'suggestion-option'

export const CONTRACT_LINE_FIELD_NAME = 'contractLine'

export { LOCAL_STORAGE_KEYS } from './localStorageKeys'
export { ROUTE_KEYS } from './routeKeys'
